import { SearchKeywords, SearchPopularSearches } from "@nosto/nosto-js/client";
import Keyword from "@/components/Autocomplete/Item/Keyword";

export type KeywordsProps = {
  keywords: SearchKeywords;
  searches: SearchPopularSearches;
};

export default function Keywords({ keywords, searches }: KeywordsProps) {
  if (!keywords?.hits?.length) {
    return null;
  }

  const excludedKeywords = new Set(searches.hits.map((item) => item.query));
  const filteredKeywords = keywords.hits.filter(
    (hit) => !excludedKeywords.has(hit.keyword),
  );

  if (filteredKeywords.length === 0) {
    return null;
  }

  return (
    <>
      {filteredKeywords.map((keyword, index) => (
        <Keyword key={index} keyword={keyword} />
      ))}
    </>
  );
}
